<template>
  <div>
    <!-- 배너 -->
    <!-- <LinkookLiveBanner :class="$style.linkookLiveBanner" /> -->
    <div :class="$style.container">
      <!-- 게시판 -->
      <div :class="$style.boardContainer">
        <!-- 카테고리 필터 -->
        <div :class="$style.categoryFilter">
          <!-- 카테고리 드롭다운 버튼 -->
          <div :class="$style.categoryDropdown" ref="dropdownContainer">
            <button :class="$style.dropdownToggle" @click.stop="toggleDropdown">
              <img src="@/assets/images/dehaze.png" alt="카테고리 메뉴" :class="$style.dehazeIcon" />
            </button>
            <div v-if="showDropdown" :class="$style.dropdownMenu">
              <button :class="[
                $style.dropdownItem,
                { [$style.activeDropdownItem]: selectedCategory === 'all' },
              ]" @click="selectCategoryFromDropdown('all')">
                전체
              </button>
              <button :class="[
                $style.dropdownItem,
                {
                  [$style.activeDropdownItem]: selectedCategory === 'notice',
                },
              ]" @click="selectCategoryFromDropdown('notice')">
                📢 공지사항
              </button>
              <button :class="[
                $style.dropdownItem,
                {
                  [$style.activeDropdownItem]: selectedCategory === 'permission',
                },
              ]" @click="selectCategoryFromDropdown('permission')">
                🔑 권한신청
              </button>
              <button :class="[
                $style.dropdownItem,
                {
                  [$style.activeDropdownItem]: selectedCategory === 'recruit',
                },
              ]" @click="selectCategoryFromDropdown('recruit')">
                💼 구인구직
              </button>
              <button :class="[
                $style.dropdownItem,
                {
                  [$style.activeDropdownItem]: selectedCategory === 'performance',
                },
              ]" @click="selectCategoryFromDropdown('performance')">
                🎭 공연후기
              </button>
              <button :class="[
                $style.dropdownItem,
                {
                  [$style.activeDropdownItem]: selectedCategory === 'recommend',
                },
              ]" @click="selectCategoryFromDropdown('recommend')">
                ⭐ 추천게시판
              </button>
              <button :class="[
                $style.dropdownItem,
                {
                  [$style.activeDropdownItem]: selectedCategory === 'songRecommend',
                },
              ]" @click="selectCategoryFromDropdown('songRecommend')">
                🎵 곡추천
              </button>
              <button v-if="userStore.auth === 'admin'" :class="[
                $style.dropdownItem,
                {
                  [$style.activeDropdownItem]: selectedCategory === 'ggookoff',
                },
              ]" @click="selectCategoryFromDropdown('ggookoff')">
                🎪 꾹오프
              </button>
              <button :class="[
                $style.dropdownItem,
                { [$style.activeDropdownItem]: selectedCategory === 'free' },
              ]" @click="selectCategoryFromDropdown('free')">
                💬 자유게시판
              </button>
              <button :class="[
                $style.dropdownItem,
                { [$style.activeDropdownItem]: selectedCategory === 'update' },
              ]" @click="selectCategoryFromDropdown('update')">
                🔄 업데이트
              </button>
              <button :class="[
                $style.dropdownItem,
                {
                  [$style.activeDropdownItem]: selectedCategory === 'bugreport',
                },
              ]" @click="selectCategoryFromDropdown('bugreport')">
                🐛 버그리포트
              </button>
            </div>
          </div>

          <div ref="filterButtonsScroll" :class="$style.filterButtons">
            <button data-category="all"
              :class="[$style.filterButton, { [$style.activeFilter]: selectedCategory === 'all' }]"
              @click="selectCategory('all')">
              전체
            </button>
            <button data-category="notice" :class="[
              $style.filterButton,
              $style.noticeFilterButton,
              { [$style.activeFilter]: selectedCategory === 'notice' },
            ]" @click="selectCategory('notice')">
              📢 공지사항
            </button>
            <button data-category="permission" :class="[
              $style.filterButton,
              { [$style.activeFilter]: selectedCategory === 'permission' },
            ]" @click="selectCategory('permission')">
              🔑 권한신청
            </button>
            <button data-category="recruit" :class="[
              $style.filterButton,
              { [$style.activeFilter]: selectedCategory === 'recruit' },
            ]" @click="selectCategory('recruit')">
              💼 구인구직
            </button>
            <button data-category="performance" :class="[
              $style.filterButton,
              { [$style.activeFilter]: selectedCategory === 'performance' },
            ]" @click="selectCategory('performance')">
              🎭 공연후기
            </button>
            <button data-category="recommend" :class="[
              $style.filterButton,
              { [$style.activeFilter]: selectedCategory === 'recommend' },
            ]" @click="selectCategory('recommend')">
              ⭐ 추천게시판
            </button>
            <button data-category="songRecommend" :class="[
              $style.filterButton,
              { [$style.activeFilter]: selectedCategory === 'songRecommend' },
            ]" @click="selectCategory('songRecommend')">
              🎵 곡추천
            </button>
            <button v-if="userStore.auth === 'admin'" data-category="ggookoff" :class="[
              $style.filterButton,
              { [$style.activeFilter]: selectedCategory === 'ggookoff' },
            ]" @click="selectCategory('ggookoff')">
              🎪 꾹오프
            </button>
            <button data-category="free"
              :class="[$style.filterButton, { [$style.activeFilter]: selectedCategory === 'free' }]"
              @click="selectCategory('free')">
              💬 자유게시판
            </button>
            <button data-category="update" :class="[
              $style.filterButton,
              { [$style.activeFilter]: selectedCategory === 'update' },
            ]" @click="selectCategory('update')">
              🔄 업데이트
            </button>
            <button data-category="bugreport" :class="[
              $style.filterButton,
              { [$style.activeFilter]: selectedCategory === 'bugreport' },
            ]" @click="selectCategory('bugreport')">
              🐛 버그리포트
            </button>
          </div>
          <!-- PC용 글쓰기 버튼 -->
          <button v-if="!userStore.isBlocked" @click="goToWrite" :class="$style.desktopWriteButton">✏️ 글쓰기</button>
        </div>

        <!-- 게시판 콘텐츠 -->
        <div :class="$style.boardContent">
          <div v-if="loadingBoard" :class="$style.loading">
            <div :class="$style.spinner"></div>
            <p>게시글을 불러오는 중...</p>
          </div>

          <div v-else-if="boardPosts.length === 0" :class="$style.emptyState">
            <div :class="$style.emptyIcon">📝</div>
            <h3>게시글이 없습니다</h3>
            <p>첫 번째 게시글을 작성해보세요!</p>
          </div>

          <div v-else :class="$style.postList">
            <!-- 공지사항 게시글 (상단 고정) -->
            <div v-for="post in noticePosts" :key="'notice-' + post.id" :class="[$style.postCard, $style.noticePost]"
              @click="goToPostDetail(post.id)">
              <div :class="$style.postHeader">
                <div :class="$style.postMeta">
                  <div :class="$style.postMetaLeft">
                    <span :class="$style.noticeBadge">📢 공지사항</span>
                    <span :class="$style.postDate">{{ formatDate(post.registeredAt) }}</span>
                  </div>
                  <div :class="$style.writerInfo">
                    <span :class="$style.postWriter">{{ post.writer }}</span>
                    <span v-if="post.writerAuth === 'admin'" :class="$style.adminEmoji">🐾</span>
                  </div>
                </div>
                <div :class="$style.postTitleRow">
                  <h3 :class="$style.postTitle">
                    <span v-if="post.isPrivate" :class="$style.lockIcon">🔒</span>
                    {{ post.title }}
                  </h3>
                  <div :class="$style.postStats">
                    <span v-if="!post.isPrivate || userStore.auth === 'admin'" :class="$style.viewCount">👀 {{ post.view
                      || 0 }}</span>
                    <span :class="$style.likeCount">👍️ {{ post.like || 0 }}</span>
                    <span :class="$style.commentCount">💬 {{ post.commentCount || 0 }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 일반 게시글 -->
            <div v-for="post in regularPosts" :key="post.id" :class="$style.postCard" @click="goToPostDetail(post.id)">
              <div :class="$style.postHeader">
                <div :class="$style.postMeta">
                  <div :class="$style.postMetaLeft">
                    <span :class="$style.categoryBadge">{{ getCategoryName(post.category) }}</span>
                    <span :class="$style.postDate">{{ formatDate(post.registeredAt) }}</span>
                  </div>
                  <div :class="$style.writerInfo">
                    <span :class="$style.postWriter">{{ post.writer }}</span>
                    <span v-if="post.writerAuth === 'admin'" :class="$style.adminEmoji">🐾</span>
                  </div>
                </div>
                <div :class="$style.postTitleRow">
                  <h3 :class="$style.postTitle">
                    <span v-if="post.isPrivate" :class="$style.lockIcon">🔒</span>
                    {{ post.title }}
                  </h3>
                  <div :class="$style.postStats">
                    <span v-if="!post.isPrivate || userStore.auth === 'admin'" :class="$style.viewCount">👀 {{ post.view
                      || 0 }}</span>
                    <span :class="$style.likeCount">👍️ {{ post.like || 0 }}</span>
                    <span :class="$style.commentCount">💬 {{ post.commentCount || 0 }}</span>
                  </div>
                </div>
                <div v-if="post.category === 'ggookoff'" :class="$style.bandOffSummary">
                  {{ getBandOffSummary(post) }}
                </div>
              </div>
            </div>
          </div>

          <!-- 페이지네이션 -->
          <div v-if="totalPages > 1" :class="$style.pagination">
            <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1"
              :class="[$style.pageButton, $style.navButton]">
              ‹
            </button>

            <button v-for="page in totalPages" :key="page" @click="changePage(page)"
              :class="[$style.pageButton, { [$style.activePage]: currentPage === page }]">
              {{ page }}
            </button>

            <button @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"
              :class="[$style.pageButton, $style.navButton]">
              ›
            </button>
          </div>
        </div>
      </div>

      <!-- 모바일 floating 버튼 -->
      <button v-if="!userStore.isBlocked" @click="goToWrite" :class="$style.floatingButton">
        <span>+ 신규등록</span>
      </button>
    </div>
  </div>
</template>

<script>
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { firestore } from "/firebaseConfig";
import { trackCommunityView } from "@/utils/statistics";
import { useUserStore } from "@/store/user";
// import LinkookLiveBanner from "@/components/layout/LinkookLiveBanner.vue";

export default {
  name: "CommunityBoard",
  components: {
    // LinkookLiveBanner,
  },
  data() {
    return {
      boardPosts: [],
      loadingBoard: false,
      selectedCategory: "all",
      currentPage: 1,
      postsPerPage: 10,
      userStore: useUserStore(),
      showDropdown: false,
    };
  },
  computed: {
    filteredPosts() {
      let posts = this.boardPosts;
      if (this.userStore.auth !== "admin") {
        posts = posts.filter((post) => post.category !== "ggookoff");
      }

      // 공지사항 전용 필터 (isNotice가 true이거나 category가 notice인 게시글)
      if (this.selectedCategory === "notice") {
        posts = posts.filter((post) => post.isNotice === true || post.category === "notice");
      }
      // 일반 카테고리 필터링
      else if (this.selectedCategory !== "all") {
        posts = posts.filter((post) => post.category === this.selectedCategory);
      }

      return posts;
    },
    noticePosts() {
      // 공지사항 탭이면 isNotice가 true인 게시글만 (눈에 띄는 스타일 유지)
      if (this.selectedCategory === "notice") {
        return this.filteredPosts.filter((post) => post.isNotice === true);
      }
      return this.filteredPosts.filter((post) => post.isNotice === true);
    },
    allRegularPosts() {
      // 공지사항 탭이면 isNotice가 아닌 게시글들 (일반 스타일)
      if (this.selectedCategory === "notice") {
        return this.filteredPosts.filter((post) => post.isNotice !== true);
      }
      return this.filteredPosts.filter((post) => post.isNotice !== true);
    },
    regularPosts() {
      const start = (this.currentPage - 1) * this.postsPerPage;
      const end = start + this.postsPerPage;
      return this.allRegularPosts.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.allRegularPosts.length / this.postsPerPage);
    },
  },
  watch: {
    selectedCategory() {
      this.$nextTick(() => this.scrollActiveCategoryIntoView());
    },
  },
  async mounted() {
    // URL 쿼리 파라미터에서 카테고리 확인
    if (this.$route.query.category) {
      this.selectedCategory = this.$route.query.category;
    }
    if (this.userStore.auth !== "admin" && this.selectedCategory === "ggookoff") {
      this.selectedCategory = "all";
    }

    await this.loadBoardPosts();

    // 커뮤니티 화면 접속 통계 추적
    trackCommunityView();

    // 외부 클릭 감지를 위한 이벤트 리스너 추가
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    // 이벤트 리스너 제거
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    async loadBoardPosts() {
      try {
        this.loadingBoard = true;

        const q = query(collection(firestore, "boards"), orderBy("registeredAt", "desc"));
        const querySnapshot = await getDocs(q);

        // 삭제되지 않은 게시글만 필터링
        const filteredDocs = querySnapshot.docs.filter((doc) => {
          const data = doc.data();
          return data.deleted !== true;
        });

        // 각 게시글의 댓글 개수를 함께 가져오기
        const postsWithComments = await Promise.all(
          filteredDocs.map(async (doc) => {
            const postData = {
              id: doc.id,
              ...doc.data(),
            };

            // 댓글 개수 가져오기 (삭제되지 않은 댓글만)
            try {
              const commentsRef = collection(firestore, "boards", doc.id, "comments");
              const commentsSnapshot = await getDocs(commentsRef);
              const activeComments = commentsSnapshot.docs.filter((commentDoc) => {
                const commentData = commentDoc.data();
                return commentData.deleted !== true;
              });
              postData.commentCount = activeComments.length;
            } catch (error) {
              postData.commentCount = 0;
            }

            return postData;
          })
        );

        this.boardPosts = postsWithComments;
      } catch (error) {
        console.error("게시판 데이터 로드 오류:", error);
      } finally {
        this.loadingBoard = false;
      }
    },

    goToPostDetail(postId) {
      // 게시글 찾기
      const post = this.boardPosts.find((p) => p.id === postId);
      if (post?.category === "ggookoff" && this.userStore.auth !== "admin") {
        this.$alert("관리자만 접근할 수 있습니다.");
        return;
      }

      // 비밀글인 경우 권한 체크
      if (post && post.isPrivate) {
        const isAdmin = this.userStore.auth === "admin";
        const isAuthor = this.userStore.email === post.writerEmail;

        if (!isAdmin && !isAuthor) {
          this.$alert("이 게시글은 비밀글입니다. 작성자와 관리자만 확인할 수 있습니다.");
          return;
        }
      }

      // 게시글 상세보기로 이동
      this.$router.push(`/board/${postId}`);
    },

    selectCategory(category) {
      this.selectedCategory = category;
      this.currentPage = 1; // 카테고리 변경 시 첫 페이지로
    },

    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },

    handleClickOutside(event) {
      const dropdownContainer = this.$refs.dropdownContainer;
      if (dropdownContainer && !dropdownContainer.contains(event.target)) {
        this.showDropdown = false;
      }
    },

    selectCategoryFromDropdown(category) {
      this.selectCategory(category);
      this.showDropdown = false;
    },

    scrollActiveCategoryIntoView() {
      const scrollEl = this.$refs.filterButtonsScroll;
      if (!scrollEl) return;
      const target = scrollEl.querySelector(`[data-category="${this.selectedCategory}"]`);
      if (target) {
        target.scrollIntoView({ inline: "center", block: "nearest", behavior: "smooth" });
      }
    },

    changePage(page) {
      this.currentPage = page;
      // 페이지 변경 시 상단으로 스크롤
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    getCategoryName(category) {
      if (!category) return ""; // 카테고리가 없는 경우 빈 문자열 반환 (공지사항)
      const categoryNames = {
        notice: "📢 공지사항",
        performance: "🎭 공연후기",
        recruit: "💼 구인구직",
        recommend: "⭐ 추천게시판",
        songRecommend: "🎵 곡추천",
        ggookoff: "🎪 꾹오프",
        free: "💬 자유게시판",
        update: "🔄 업데이트",
        permission: "🔑 권한신청",
        bugreport: "🐛 버그리포트",
      };
      return categoryNames[category] || "게시판";
    },

    goToWrite() {
      if (!this.userStore.isLogin) {
        this.userStore.showLoginPopup('communityRegister');
        return;
      }
      this.$router.push("/board/write");
    },

    formatDate(timestamp) {
      if (!timestamp) return "날짜 정보 없음";

      try {
        const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
        const now = new Date();
        const diffMs = now - date;
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        const diffMinutes = Math.floor(diffMs / (1000 * 60));

        // 오늘 올라온 글인 경우
        if (diffHours < 24 && date.getDate() === now.getDate()) {
          if (diffMinutes < 1) {
            return "방금 전";
          } else if (diffMinutes < 60) {
            return `${diffMinutes}분 전`;
          } else {
            return `${diffHours}시간 전`;
          }
        }

        // 그 외의 경우 날짜 표시
        return date.toLocaleDateString("ko-KR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      } catch (error) {
        return "날짜 정보 없음";
      }
    },
    getBandOffSummary(post) {
      const config = post.bandOffConfig || {};
      const status = config.recruitStatus === "closed" ? "마감" : "모집중";
      const current = Number.isFinite(config.currentParticipants) ? config.currentParticipants : 0;
      const max = Number.isFinite(config.maxParticipants) ? config.maxParticipants : 0;
      const capacityText = max > 0 ? `${current}/${max}` : `${current}/∞`;
      return `꾹오프 ${status} · 참가 ${capacityText}`;
    },
  },
};
</script>

<style module>
.container {
  width: 90%;
  margin: 0 auto;
  padding: 0px 0px;
  font-family: "NanumSquareRoundR", sans-serif;
}


/* 광고 지면 */
.header {
  text-align: center;
  margin-bottom: 30px;
}

.title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  font-family: "NanumSquareRoundB", sans-serif;
}

.subtitle {
  font-size: 1.1rem;
  color: #666;
  margin: 0;
}

/* Medium: 481px ~ (기본 스타일, 최대 1024px) */
/* 게시판 컨테이너 */
.boardContainer {
  background: transparent;
  width: 100%;
  margin: auto;
}

.boardContent {
  padding: 0;
}

/* 카테고리 필터 (ArtistList typeFilter와 동일 스타일) */
.categoryFilter {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
  min-width: 0;
  padding: 10px 5px;
}

.filterButtons {
  display: flex;
  gap: 8px;
  align-items: center;
  overflow-x: auto;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.filterButtons::-webkit-scrollbar {
  display: none;
}

.filterButton {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundB", sans-serif;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
}

.filterButton:hover {
  background: #f8f9fa;
  border-color: #cbd5e1;
  color: #334155;
}

.filterButton.activeFilter {
  background: #66bdff;
  color: white;
  border-color: #66bdff;
}

.noticeFilterButton {
  border-color: #fbbf24;
  color: #f59e0b;
}

.noticeFilterButton:hover {
  background: #fef3c7;
  border-color: #fbbf24;
  color: #d97706;
}

.noticeFilterButton.activeFilter {
  background: #f59e0b;
  color: white;
  border-color: #f59e0b;
}

/* 카테고리 드롭다운 (ArtistList typeDropdown과 동일) */
.categoryDropdown {
  position: relative;
  flex-shrink: 0;
}

.dropdownToggle {
  height: 34px;
  width: 34px;
  border-radius: 15px;
  background: white;
  border: 1px solid #ddd;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-family: "NanumSquareRoundR", sans-serif;
}

.dropdownToggle:hover {
  background: #f8f9fa;
  border-color: #cbd5e1;
}

.dehazeIcon {
  width: 22px;
  height: 22px;
  object-fit: contain;
  filter: brightness(0) invert(0.4);
  /* #666 */
}

.dropdownMenu {
  position: absolute;
  top: calc(100% + 8px);
  left: 5px;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  min-width: 160px;
  max-height: 70vh;
  overflow-y: auto;
  animation: slideDown 0.2s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdownItem {
  width: 100%;
  padding: 10px 14px;
  background: white;
  border: none;
  text-align: left;
  font-size: 0.875rem;
  color: #64748b;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: "NanumSquareRoundR", sans-serif;
  border-bottom: 1px solid #f1f5f9;
}

.dropdownItem:last-child {
  border-bottom: none;
}

.dropdownItem:hover {
  background: #f8fafc;
  color: #334155;
}

.dropdownItem.activeDropdownItem {
  background: #1e293b;
  color: white;
  font-weight: bold;
}

/* 로딩 상태 */
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #66bdff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* 빈 상태 */
.emptyState {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.emptyIcon {
  font-size: 48px;
  margin-bottom: 20px;
}

.emptyState h3 {
  margin: 0 0 10px 0;
  font-size: 1.2rem;
  color: #333;
}

.emptyState p {
  margin: 0;
  font-size: 0.9rem;
}

/* 게시글 목록 */
.postList {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.postCard {
  display: flex;
  flex-direction: row;
  background: white;
  padding: 10px 15px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  border-bottom: 1px solid #f1f5f9;
}

.postCard:hover {
  background: #fafbfc;
}

.postCard:last-child {
  border-bottom: none;
}

/* 공지사항 게시글 */
.noticePost {
  background: #f0f9ff;
  border-left: 3px solid #66bdff;
  padding-left: 15px;
}

.noticePost:hover {
  background: #e0f2fe;
}

.noticeLabel {
  margin-bottom: 8px;
}

.noticeBadge {
  display: inline-block;
  background: #66bdff;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  font-family: "NanumSquareRoundB", sans-serif;
  box-shadow: 0 0 8px rgba(102, 189, 255, 0.3);
}

.postHeader {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.postHeaderRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.postTitleRow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.categoryBadge {
  display: inline-block;
  padding: 2px 6px;
  background: #f1f5f9;
  color: #64748b;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 500;
  font-family: "NanumSquareRoundR", sans-serif;
}

.postTitle {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: #0f172a;
  font-family: "NanumSquareRoundB", sans-serif;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.lockIcon {
  flex-shrink: 0;
  font-size: 0.85rem;
  opacity: 0.7;
}

.postMeta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.75rem;
  color: #94a3b8;
  margin-bottom: 4px;
}

.postMetaLeft {
  display: flex;
  gap: 8px;
  align-items: center;
}

.writerInfo {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  margin-right: 10px;
}

.adminEmoji {
  font-size: 12px;
  line-height: 1;
  flex-shrink: 0;
}

.postWriter {
  font-weight: 500;
  color: #64748b;
}

.postDate {
  color: #94a3b8;
}

.postDate::before {
  content: "•";
  margin: 0 4px;
  color: #cbd5e1;
}

.postStats {
  display: flex;
  align-items: center;
  margin-right: 10px;
  gap: 2px;
}

.likeCount {
  font-size: 0.8rem;
  color: #64748b;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 2px;
  margin-right: 12px;
}

.viewCount {
  font-size: 0.8rem;
  color: #64748b;
  font-weight: 500;
  margin-right: 12px;
}

.commentCount {
  font-size: 0.8rem;
  color: #64748b;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 2px;
}

.bandOffSummary {
  margin-top: 4px;
  font-size: 0.72rem;
  color: #1d4ed8;
}

.postContent {
  color: #475569;
  line-height: 1.5;
  font-size: 0.8rem;
}

.postFooter {
  display: none;
}

/* PC용 글쓰기 버튼 스타일 */
.desktopWriteButton {
  display: none;
  padding: 10px 20px;
  background: #66bdff;
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 0.9rem;
  font-weight: bold;
  font-family: "NanumSquareRoundB", sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(102, 189, 255, 0.3);
}

.desktopWriteButton:hover {
  background: #4a9eff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 189, 255, 0.4);
}

.desktopWriteButton:active {
  transform: translateY(0);
}

/* 페이지네이션 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: 20px 15px;
  margin-top: 20px;
}

.pageButton {
  padding: 6px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #ffffff;
  color: #666;
  font-size: 0.8125rem;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 32px;
  text-align: center;
}

.pageButton:hover:not(.activePage):not(:disabled) {
  background: #f8f9fa;
  border-color: #ccc;
  color: #333;
}

.pageButton:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  color: #ccc;
  background: #f8f9fa;
}

.pageButton.activePage {
  background: #222;
  color: #ffffff;
  border-color: #222;
}

.navButton {
  font-size: 16px;
  font-weight: bold;
}

/* Floating 버튼 스타일 */
.floatingButton {
  position: fixed;
  right: calc(50% - 500px);
  max-width: 1024px;
  margin-right: 12px;
  height: 46px;
  padding: 0px 12px;
  border-radius: 30px;
  background: #66bdff;
  color: white;
  border: none;
  box-shadow: 0 4px 16px rgba(102, 189, 255, 0.4);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 199;
  font-size: 1rem;
  font-weight: bold;
  font-family: "NanumSquareRoundB", sans-serif !important;
  transition: all 0.3s ease;
  bottom: 80px;
}

.floatingButton:hover {
  background: #4a9eff;
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(102, 189, 255, 0.6);
}

.floatingButton:active {
  transform: scale(0.95);
}

@media screen and (max-width: 1024px) {
  .floatingButton {
    right: 12px;
    /* 1024px 이하에서는 기존 위치 유지 */
  }
}

/* ========================================
   Small (~480px)
   ======================================== */
@media screen and (max-width: 480px) {

  .container {
    width: 100%;
  }

  .postCard {
    padding: 8px 12px;
  }

  .postTitle {
    font-size: 0.75rem;
  }

  .postWriter {
    max-width: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.6875rem;
  }

  .postDate {
    font-size: 0.625rem;
  }

  .postMeta {
    font-size: 0.6875rem;
  }

  .postContent {
    font-size: 0.75rem;
  }

  .likeCount {
    font-size: 0.6875rem;
    margin-right: 8px;
  }

  .viewCount {
    font-size: 0.6875rem;
    margin-right: 8px;
  }

  .commentCount {
    font-size: 0.6875rem;
    margin-right: 0px;
  }

  .categoryBadge {
    font-size: 0.625rem;
  }

  .noticeBadge {
    font-size: 0.625rem;
  }

  .filterButton {
    padding: 6px 12px;
    font-size: 0.75rem;
  }

  .dropdownToggle {
    height: 28px;
    width: 28px;
    border-radius: 10px;
    margin-left: 5px;
  }

  .dehazeIcon {
    width: 18px;
    height: 18px;
  }

  .dropdownItem {
    padding: 10px 12px;
    font-size: 0.8125rem;
  }

  .pagination {
    gap: 4px;
    margin-top: 18px;
    padding: 15px 10px;
  }

  .pageButton {
    padding: 5px 8px;
    font-size: 0.6875rem;
    min-width: 26px;
    border-radius: 5px;
  }

  .navButton {
    font-size: 14px;
  }
}
</style>
